export default __webpack_public_path__ + "static/Grappling_Hook-eaa1c00928544933a74f7ca94d8e6265.png";